import { useState, useEffect } from 'react'
import { supabase } from '../../lib/supabase'
import CategoryCard from './CategoryCard'
import SubCategoryCard from './SubCategoryCard'
import DashboardCard from './DashboardCard'
import Visor from '../generic/Visor'

interface DatosGeneralesProps {
  onSelectDashboard: (id: number) => void
  selectedCategory: any | null
  selectedSubCategory: string | null
  onSelectCategory: (category: any | null) => void
  onSelectSubCategory: (subCategoryId: string | null) => void
}

export default function DatosGenerales({ 
  onSelectDashboard, 
  selectedCategory, 
  selectedSubCategory, 
  onSelectCategory, 
  onSelectSubCategory 
}: DatosGeneralesProps) {
    const [categories, setCategories] = useState<any[]>([])
    const [subcategories, setSubcategories] = useState<any[]>([])
    const [dashboards, setDashboards] = useState<any[]>([])

    useEffect(() => {
        loadCategories()
    }, [])

    // Cuando cambia selectedCategory, cargar subcategorías
    useEffect(() => {
        if (selectedCategory) {
            loadSubcategories(selectedCategory.id)
        } else {
            setSubcategories([])
            setDashboards([])
        }
    }, [selectedCategory])

    // Cuando cambia selectedSubCategory, cargar dashboards
    useEffect(() => {
        if (selectedSubCategory) {
            loadDashboards(selectedSubCategory)
        } else {
            setDashboards([])
        }
    }, [selectedSubCategory])

    const loadCategories = async () => {
        const { data, error } = await supabase
        .from('categories')
        .select('id, name, img, description')
        .is('parent_id', null)
        .neq('id', 7)
        .or('show_species_data.is.null,show_species_data.eq.false')
        .order('orderlevel', { ascending: true })

        /*const { data, error } = await supabase
        .from('existencias_forestales')
        .select('id_municipio, total:count(), municipios(nombre)');*/

        console.log('dataa', data);

        if (!error) setCategories(data || [])
    }

    const loadSubcategories = async (parentId: string) => {
        const { data, error } = await supabase
            .from('categories')
            .select('id, name, img, description')
            .eq('parent_id', parentId)

        if (!error) setSubcategories(data || [])
    }

    const loadDashboards = async (subcategoryId: string) => {
        const { data, error } = await supabase
            .from('dashboards')
            .select('id, name, description, slug')
            .eq('subcategory_id', subcategoryId)
            .order('created_at', { ascending: true })
            .not('id', 'in', '(826dae83-1592-46b9-ab1d-4d7d99f3aad8,d6d480aa-d1a3-4b35-89ad-eed52b7417e1,c6cc2ea3-36ae-4117-ad33-7243edbe4f4e,14b74b16-cc27-41b6-ac3f-16da77cae9e7)')

        if (!error) setDashboards(data || [])
    }

    const handleSelectCategory = (category: any) => {
        onSelectCategory(category)
        onSelectSubCategory(null)
    }

    const handleBackToCategories = () => {
        onSelectCategory(null)
        onSelectSubCategory(null)
    }

    return (
    <div className='bg-card border rounded-lg p-6'>
    <div className='grid grid-cols-1 lg:grid-cols-2 gap-4'>
        <div className='border rounded-lg p-4 transition-all '>
            <div 
                className="bg-white rounded-2xl shadow-sm border border-gray-200 p-4 gap-4 w-full 
                            max-h-[100vh] overflow-y-auto"
                >
            {!selectedCategory && (
                <>
                <h3 className="text-lg font-semibold text-gray-700 flex items-center gap-2">Categorías</h3>
                <p className="text-sm text-gray-500">Explora las diferentes categorías</p>
                </>
            )}
            
            <br />
            <div className='grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4  overflow-y-auto'>
                {/* Si hay categoría seleccionada → mostrar subcategorías */}
                {selectedCategory ? (
                <>
                    {/* Encabezado con botón volver */}
                    <div className="flex flex-col space-y-2 mb-3">
                        <button
                            onClick={() => handleBackToCategories()}
                            className="flex items-center gap-2 text-sm text-teal-700 font-medium hover:underline"
                        >
                            ← Volver
                        </button>

                        <h4 className="text-md font-semibold text-gray-700">
                            {selectedCategory.name}
                        </h4>

                        <p className="text-sm text-gray-600 line-clamp-2">
                            Da click a alguna sub categoría para visualizar los diferentes dashboard disponibles
                        </p>
                    </div>

                    {/* Chips horizontales de subcategorías */}
                   <div className="flex gap-2 overflow-x-auto pb-3 mt-1">
                        {subcategories.map((sub) => (
                            <SubCategoryCard
                            key={sub.id}
                            id={sub.id}
                            name={sub.name}
                            active={selectedSubCategory === sub.id}
                            onClick={() => {
                                onSelectSubCategory(sub.id)
                            }}
                            />
                        ))}
                    </div>

                    {/* Tarjetas de dashboards */}
                    {dashboards.length > 0 ? (
                        <div className="mt-4 grid grid-cols-1 gap-3">
                            {dashboards.map((d) => (
                                <DashboardCard
                                key={d.id}
                                id={d.id}
                                name={d.name}
                                slug={d.slug}
                                description={d.description}
                                onSelectDashboard={onSelectDashboard}
                                />
                            ))}
                        </div>
                    ) : selectedSubCategory ? (
                        <div className="mt-4 grid grid-cols-1 gap-3">
                            <p className="text-gray-600 mb-6">
                                No existen dashboards para la categoría seleccionada.
                            </p>
                        </div>
                    ) : null}
                </>
                ) : (
                /* Vista normal: categorías principales */
                categories.map((cat) => (
                    <CategoryCard
                    key={cat.id}
                    name={cat.name}
                    description={cat.description}
                    image={cat.img}
                    onClick={() => handleSelectCategory(cat)}
                    />
                ))
                )}
            </div>
        </div>
        </div>
        <div className='border rounded-lg p-4 transition-all'>
            <Visor
                center={[40.42, -3.70]}
                height="100vh"
            />
        </div>
    </div>
    </div>
    )
}